import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

interface ActionButtonProps extends ComponentPropsWithoutRef<typeof Button> {
  children: ReactNode;
  iconEl?: ReactNode;
}

export function ActionButton({ children, iconEl, ...rest }: ActionButtonProps) {
  return (
    <Button variant="secondary" large {...rest}>
      <div className="text-darkest flex gap-x-2">
        {iconEl}
        <Typography.LabelMd weight="semibold" color="text-darkest">
          {children}
        </Typography.LabelMd>
      </div>
    </Button>
  );
}
